/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon34Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g clipPath={"url(#a)"}>
        <path
          stroke={"#292929"}
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          d={"M9.375 9.375A.625.625 0 0 1 10 10v3.125a.624.624 0 0 0 .625.625"}
        ></path>

        <path
          fill={"#292929"}
          d={"M9.688 7.188a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"}
        ></path>

        <path
          stroke={"#292929"}
          d={
            "M15 17.5h2a1 1 0 0 0 1-1v-13a1 1 0 0 0-1-1h-2m-10 0H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h2"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon34Icon;
/* prettier-ignore-end */
